"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var esri_loader_1 = require("esri-loader");
var SmokeLayer = function (_a) {
    var url = _a.url, timeExtent = _a.timeExtent, visible = _a.visible, mapView = _a.mapView;
    var _b = React.useState(), smokeLayer = _b[0], setSmokeLayer = _b[1];
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, MapImageLayer, FeatureLayer, TimeExtent, smokeLayer_1, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, esri_loader_1.loadModules([
                            'esri/layers/MapImageLayer',
                            'esri/layers/FeatureLayer',
                            'esri/TimeExtent'
                        ])];
                case 1:
                    _a = _b.sent(), MapImageLayer = _a[0], FeatureLayer = _a[1], TimeExtent = _a[2];
                    smokeLayer_1 = new MapImageLayer({
                        url: url,
                        visible: visible,
                        useViewTime: false,
                        opacity: .5
                    });
                    mapView.map.add(smokeLayer_1, 0);
                    setSmokeLayer(smokeLayer_1);
                    return [3, 3];
                case 2:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var updateTimeExtent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var TimeExtent, startTime, endTime;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, esri_loader_1.loadModules([
                        'esri/TimeExtent'
                    ])];
                case 1:
                    TimeExtent = (_a.sent())[0];
                    startTime = timeExtent[0], endTime = timeExtent[1];
                    smokeLayer.timeExtent = new TimeExtent({
                        start: new Date(startTime),
                        end: new Date(endTime)
                    });
                    smokeLayer.visible = visible;
                    return [2];
            }
        });
    }); };
    React.useEffect(function () {
        if (mapView) {
            init();
        }
    }, [mapView]);
    React.useEffect(function () {
        if (!smokeLayer) {
            return;
        }
        if (timeExtent) {
            updateTimeExtent();
        }
    }, [visible, timeExtent]);
    return null;
};
exports.default = SmokeLayer;
